import React, { useEffect } from 'react';

interface PDFViewerModalProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
  title?: string;
  width?: string;
  height?: string;
}

const PDFViewerModal: React.FC<PDFViewerModalProps> = ({
  isOpen,
  onClose,
  url,
  title = 'PDF Document',
  width = '90vw',
  height = '80vh',
}) => {
  useEffect(() => {
    if (isOpen && url) {
      // Automatically open PDF in new tab and close modal
      window.open(url, '_blank', 'noopener,noreferrer');
      onClose();
    }
  }, [isOpen, url, onClose]);

  // Don't render anything since we're just opening in new tab
  return null;
};

export default PDFViewerModal;
